module.exports = __webpack_public_path__ + "static/media/sort-alpha-down-alt.ff02f917.svg";